(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jf-featured"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(el) {
    if (!el || el.dataset.jfInit) return;
    el.dataset.jfInit = '1';

    const track    = el.querySelector('.jf-carousel__track');
    const viewport = el.querySelector('.jf-carousel__viewport');
    const prevBtn  = el.querySelector('.jf-carousel__arrow--prev');
    const nextBtn  = el.querySelector('.jf-carousel__arrow--next');
    const items    = Array.from(track ? track.children : []);
    if (!track || !viewport || !prevBtn || !nextBtn || !items.length) return;

    let pos = 0;

    function isPhone() {
      return window.innerWidth < 750;
    }

    function visibleCount() {
      return isPhone() ? 2 : 4;
    }

    function stride() {
      const w = items[0].getBoundingClientRect().width;
      return (w > 4 ? w : viewport.getBoundingClientRect().width / visibleCount()) + 12;
    }

    function maxPos() {
      return Math.max(0, items.length - visibleCount());
    }

    function render() {
      if (isPhone()) {
        track.style.transform = '';
        return;
      }
      const s = stride();
      if (s <= 12) return; // layout not ready yet; skip
      track.style.transform = `translateX(${-pos * s}px)`;
      prevBtn.hidden = pos === 0;
      nextBtn.hidden = pos >= maxPos();
    }

    prevBtn.addEventListener('click', () => { pos = Math.max(0, pos - 1); render(); });
    nextBtn.addEventListener('click', () => { pos = Math.min(maxPos(), pos + 1); render(); });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        pos = Math.min(pos, maxPos());
        track.style.transition = 'none';
        render();
        requestAnimationFrame(() => { track.style.transition = ''; });
      }, 150);
    });

    let startX = 0, dragging = false;
    viewport.addEventListener('pointerdown', (e) => {
      if (isPhone()) return;
      if (e.target instanceof Element && e.target.closest('[data-jf-wishlist-toggle]')) return;
      startX = e.clientX;
      dragging = true;
    });
    viewport.addEventListener('pointermove', (e) => { if (!dragging || isPhone()) return; e.preventDefault(); });
    viewport.addEventListener('pointerup', (e) => {
      if (!dragging || isPhone()) return;
      dragging = false;
      const diff = startX - e.clientX;
      if (Math.abs(diff) > 40) {
        pos = diff > 0 ? Math.min(maxPos(), pos + 1) : Math.max(0, pos - 1);
        render();
      }
    }, { passive: false });

    // First render — retry if layout not ready
    render();
    if (nextBtn.hidden && maxPos() > 0) {
      // Items had no width yet — retry after a paint
      requestAnimationFrame(() => { render(); });
    }
  }

  function watchCarousel(el) {
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          io.disconnect();
          initCarousel(el);
        }
      }, { threshold: 0.05 });
      io.observe(el);
    } else {
      initCarousel(el);
    }
  }

  function setupAll() {
    document.querySelectorAll('.jf-carousel').forEach(watchCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
